import React, {
  useMemo,
  useState,
  useEffect,
  useContext,
} from "react";
import "./Cart.css";
import CartHeader from "./Header";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { KioskAuthContext } from "../../../ContextAPI/KisokContext";
import itemImg from "../../../Assets/items.png";

const CART_KEY = "fliplyn_cart";

export default function CartSummary() {
  const navigate = useNavigate();
  const { ownerId, token } = useContext(KioskAuthContext);

  const [cart, setCart] = useState({});
  const [isSaving, setIsSaving] = useState(false);

  /* ---------------- LOAD CART ---------------- */
  useEffect(() => {
    const savedCart =
      JSON.parse(localStorage.getItem(CART_KEY)) || {};
    setCart(savedCart);
    console.log("🛒 Cart loaded:", savedCart);
  }, []);

  /* ---------------- LOAD MENU ITEMS (FIX) ---------------- */
  const items = useMemo(() => {
    const stored =
      JSON.parse(localStorage.getItem("menuItemsList")) || [];
    console.log("📦 Menu items loaded:", stored.length);
    return stored;
  }, []);

  /* ---------------- BUILD CART ITEMS ---------------- */
  const cartItemList = useMemo(() => {
    console.log("🔎 Building cartItemList");

    return items
      .map((item) => {
        const qty =
          cart[item.id] ??
          cart[String(item.id)] ??
          0;

        return qty > 0
          ? { ...item, quantity: qty }
          : null;
      })
      .filter(Boolean);
  }, [cart, items]);

  /* ---------------- CART MUTATIONS ---------------- */
  const updateCart = (newCart) => {
    setCart(newCart);
    localStorage.setItem(
      CART_KEY,
      JSON.stringify(newCart)
    );
    console.log("💾 Cart updated:", newCart);
  };

  const increaseQty = (id) => {
    updateCart({
      ...cart,
      [id]: (cart[id] || 0) + 1,
    });
  };

  const decreaseQty = (id) => {
    const updated = { ...cart };
    if (updated[id] > 1) updated[id] -= 1;
    else delete updated[id];
    updateCart(updated);
  };

  const handleAddMore = () => navigate("/stalls-user");

  /* ---------------- SAVE CART TO BACKEND ---------------- */
  const handleSelectPayment = async () => {
    if (!ownerId || !token) {
      alert("Session expired");
      return;
    }

    if (!Object.keys(cart).length) {
      alert("Cart is empty");
      return;
    }

    setIsSaving(true);

    try {
      const payload = {
        items: Object.entries(cart).map(
          ([id, qty]) => ({
            item_id: id,
            quantity: qty,
          })
        ),
      };

      console.log("🚀 Sending payload:", payload);

      await axios.post(
        `https://fliplyn-b-c.fly.dev/owner/cart/add-multiple/${ownerId}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      updateCart({});
      navigate("/payment");
    } catch (err) {
      console.error("❌ Save failed:", err);
      alert("Failed to save cart");
    } finally {
      setIsSaving(false);
    }
  };

  /* ---------------- EMPTY CART ---------------- */
  if (!cartItemList.length) {
    return (
      <>
        <CartHeader />
        <div className="cart-summary-container">
          🛒 No items in cart
        </div>
      </>
    );
  }

  /* ---------------- TOTALS ---------------- */
  const subtotal = cartItemList.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  const gst = subtotal * 0.05;
  const total = subtotal + gst;

  /* ---------------- RENDER ---------------- */
  return (
    <>
      <CartHeader />

      <div className="cartPage-container">
        <div className="cartPage-basketCard">
          <h2 className="cartPage-title">Your Basket</h2>

          <div className="cartPage-itemsContainer">
            {cartItemList.map((item) => (
              <div
                key={item.id}
                className="cartPage-item"
              >
                <img
                  src={item.image_url || itemImg}
                  alt={item.name}
                  className="cartPage-itemImage"
                />

                <div className="cartPage-itemDetails">
                  <p className="cartPage-itemName">
                    {item.name}
                  </p>
                </div>

                <div className="cartPage-itemBottom">
                  <div className="cartPage-itemPrice">
                    ₹{item.price}
                  </div>

                  <div className="cartPage-qtyControls">
                    <button
                      onClick={() =>
                        decreaseQty(item.id)
                      }
                    >
                      −
                    </button>
                    <span>{item.quantity}</span>
                    <button
                      onClick={() =>
                        increaseQty(item.id)
                      }
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>
            ))}

            <button
              className="cartPage-addMoreBtn"
              onClick={handleAddMore}
            >
              ADD MORE ITEMS
            </button>
          </div>

          <div className="cartPage-totals">
            <div className="cartPage-totalRow">
              <span>Subtotal</span>
              <span>₹{subtotal.toFixed(2)}</span>
            </div>

            <div className="cartPage-totalRow">
              <span>GST</span>
              <span>₹{gst.toFixed(2)}</span>
            </div>

            <div className="cartPage-totalRow cartPage-bold">
              <span>Total</span>
              <span>₹{total.toFixed(2)}</span>
            </div>
          </div>

          <button
            className="cartPage-selectPaymentBtn"
            onClick={handleSelectPayment}
            disabled={isSaving}
          >
            {isSaving ? "Saving..." : "Select Payment"}
          </button>
        </div>
      </div>
    </>
  );
}
